import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "extended-event-analysis-extra-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSwitch = _resolveComponent("NSwitch")!
  const _component_NForm = _resolveComponent("NForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NSwitch, {
      label: _ctx.$t('common.extended_event_analysis_extra_settings'),
      modelValue: _ctx.showExtraSettings,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showExtraSettings) = $event))
    }, null, 8, ["label", "modelValue"]),
    (_ctx.showExtraSettings)
      ? (_openBlock(), _createBlock(_component_NForm, {
          key: 0,
          layout: _ctx.layout,
          model: _ctx.item
        }, null, 8, ["layout", "model"]))
      : _createCommentVNode("", true)
  ]))
}